import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchResidents } from '../../api';
import type { Resident, Image } from '@zs/shared/schema';

const IMAGE_BASE_URL = import.meta.env.VITE_IMAGE_URL || '';

const STATUS_LABELS: Record<string, string> = {
  'new': 'Новий',
  'in-clinic': 'На лікуванні',
  'kept': 'Готовий до усиновлення',
  'adopted': 'Усиновлений',
  'dead': 'Помер',
};

function getImageUrl(image: Image): string {
  return `${IMAGE_BASE_URL}/images/${image.storageKey}`;
}

function getStatusClass(status: string): string {
  if (status === 'adopted') return 'adopted';
  if (status === 'in-clinic') return 'treatment';
  if (status === 'kept') return '';
  if (status === 'new') return 'new';
  return '';
}

export default function DefaultHome() {
  const [residents, setResidents] = useState<Resident[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchResidents()
      .then((data) => setResidents(data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="default-loading">
        <div className="default-spinner"></div>
        <p>Завантаження...</p>
      </div>
    );
  }

  return (
    <div>
      <section className="default-hero">
        <h1 className="default-hero-title">жмут щастя</h1>
        <p className="default-hero-subtitle">Притулок для тварин</p>
        <span className="default-hero-count">{residents.length} РЕЗИДЕНТІВ</span>
      </section>

      <section className="default-residents-section">
        <div className="default-residents-grid">
          {residents.map((resident) => {
            const images = resident.images || [];
            const mainImage = images[0];
            
            return (
              <Link
                key={resident._id}
                to={`/resident/${resident._id}`}
                className="default-resident-card"
              >
                {mainImage ? (
                  <img
                    src={getImageUrl(mainImage)}
                    alt={resident.name}
                    loading="lazy"
                  />
                ) : (
                  <div className="default-resident-placeholder">
                    <span>📷</span>
                    <small> немає фото</small>
                  </div>
                )}
                <h3 className="default-resident-name">{resident.name}</h3>
                <span className={`default-status-badge ${getStatusClass(resident.status)}`}>
                  {STATUS_LABELS[resident.status] || resident.status}
                </span>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
